<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M12 2a10 10 0 0 1 7 3 10 10 0 0 1 2.2 10.9A10 10 0 0 1 12 22a10 10 0 0 1-7-3A10 10 0 0 1 2.7 8.2 10 10 0 0 1 12 2M7 8.5l3.5 3.5L7 15.5 8.5 17l3.5-3.5 3.5 3.5 1.5-1.5-3.5-3.5L17 8.5l-.4-.3L15.5 7 12 10.5 8.5 7z"
      clip-rule="evenodd"
    />
  </svg>
</template>
